import React, {Component} from 'react';
import { Button, Icon, Badge } from 'antd';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {fetchBranches} from '../../actions';
import PaginatedList from '../PaginatedList';

class Branches extends Component {
    render() {
        const {fetchBranches, branches, landlord, match, location: {search}} = this.props;
        const columns = [{
            title: 'Branch Name',
            dataIndex: 'branch_name',
            key: 'branch_name',
            render: (text, record) => (
                <span>
                    {record.main_office ? (
                        <Badge status="success" title="Main Office">
                            <Link to={{
                                pathname: `${match.url}/${record.id}/edit`,
                                state: {
                                    from: search || 'page=1'
                                }
                            }}>{text}</Link>
                        </Badge>
                    ) : (
                        <Link to={{
                            pathname: `${match.url}/${record.id}/edit`,
                            state: {
                                from: search || 'page=1'
                            }
                        }}>{text}</Link>
                    )}
                </span>
            )
        }, {
            title: 'Address Line 1',
            dataIndex: 'address_line_1',
            key: 'address_line_1'
        }, {
            title: 'Address Line 2',
            dataIndex: 'address_line_2',
            key: 'address_line_2'
        }, {
            title: 'Address Line 3',
            dataIndex: 'address_line_3',
            key: 'address_line_3'
        }, {
            title: 'Postcode',
            dataIndex: 'post_code',
            key: 'post_code'
        }, {
            title: 'Main Contact',
            dataIndex: 'contact_name',
            key: 'contact_name'
        }, {
            title: 'Main Contact Tel.',
            dataIndex: 'phone_number',
            key: 'phone_number'
        }, {
            title: 'Main Contact Email',
            dataIndex: 'email',
            key: 'email'
        }];

        const fetch = (id) => {
            return fetchBranches(landlord, id);
        };
        return (
            <div>
                <Button style={{marginBottom: 10}} type="primary">
                    <Link to={`${match.url}/new`}><Icon type="plus"/> New</Link>
                </Button>
                <PaginatedList
                    fetchData={fetch}
                    columns={columns}
                    source={branches}
                    {...this.props}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const branches = state.landlord.branches;
    return {
        landlord: state.me.application.id,
        loading: branches.isFetching,
        branches: [...branches.data],
        meta: branches.meta
    };
};

export default connect(mapStateToProps, {fetchBranches})(Branches);


// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/Branches.js